"use client";

import type { Locale } from "@i18n/react";
import type { Router } from "next/router";

import { getFramework } from "./utils";

const framework = getFramework();

export let useSetLocale: () => {
  setLocale: ({ locale }: { locale: Locale }) => void;
};
if (framework === "next") useSetLocale = require("@i18n/next").useSetLocale;
else if (framework === "rr")
  import("@i18n/rr").then(({ useSetLocale: useSetLocaleRr }) => {
    useSetLocale = useSetLocaleRr;
  });
/** TODO */ else useSetLocale = () => ({ setLocale: () => {} });

type UseParams = <
  T extends Record<string, string> = Record<string, string>,
>() => T;
export let useParams: UseParams;
if (framework === "next") useParams = require("next/navigation").useParams;
else if (framework === "rr")
  import("react-router").then(({ useParams: useParamsRr }) => {
    useParams = useParamsRr as UseParams;
  });
/** TODO */ else
  useParams = <T extends Record<string, string> = Record<string, string>>() =>
    ({}) as T;

export let usePath: () => string;
if (framework === "next") usePath = require("@i18n/next").usePathname;
else if (framework === "rr")
  import("react-router").then(({ useLocation: useLocationRr }) => {
    usePath = () => useLocationRr().pathname;
  });
else usePath = () => window?.location?.pathname;

export let useSearch: () => URLSearchParams;
if (framework === "next")
  useSearch = require("next/navigation").useSearchParams;
else if (framework === "rr")
  import("react-router").then(({ useSearchParams: useSearchParamsRr }) => {
    useSearch = () => useSearchParamsRr()[0];
  });
else useSearch = () => new URLSearchParams(window?.location?.search);

export let useRouter: () => Pick<
  Router,
  "push" | "replace" | "forward" | "back"
>;
if (framework === "next") useRouter = require("next/navigation").useRouter;
/* TODO */ else
  useRouter = () => ({
    forward: async () => {
      history.forward();
      return true;
    },
    back: history.back,
    push: async (url: string) => {
      history.pushState(null, null, url);
      return true;
    },
    replace: async (url: string) => {
      history.replaceState(null, null, url);
      return true;
    },
  });
